import axios from 'axios';

import type {
  IUserSetChatStatusRequest,
  IUserSetChatStatusResponse,
} from '@/app-package';

const setChatStatus = async (isChatInactive: boolean) => {
  const config: IUserSetChatStatusRequest = {
    url: '/user/set_chat_status',
    method: 'post',
    params: { isChatInactive },
  };

  const { data } = await axios.request<IUserSetChatStatusResponse>(config);

  return data;
};

export default setChatStatus;
